import React, { memo } from 'react'
import { Snackbar as MuiSnackbar } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert';

const Snackbar = ({
  open,
  handleClose,
  type,
  content
}) => (
  <MuiSnackbar
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    open={open}
    autoHideDuration={6000}
    onClose={handleClose}
  >
    <Alert
      elevation={6}
      variant="filled"
      severity={type}
      onClose={handleClose}
    >
      {content}
    </Alert>
  </MuiSnackbar>
)

Snackbar.defaultProps = {
  type: 'info'
}

export default memo(Snackbar)
